import { getDocument } from '@atlaskit/browser-apis';

import { MAIN_CONTENT_SELECTOR } from '../../ui/utils/scroll-container';

/**
 * The microsite renders inside ADS's `<Root>`/`<Main>`, and it is `<Main>`,
 * not the document, that carries `overflow-y: auto`. The document therefore
 * never scrolls, which makes `window.scrollTo` a no-op, and because `<Main>`
 * outlives every route change its `scrollTop` survives the navigation.
 *
 * So reset the window (for hosts that really do scroll the document) plus the
 * main content landmark and every ancestor above it that holds an offset, which
 * keeps working if ADS moves the `overflow` onto a different wrapper.
 */
export const scrollToTop = (): void => {
	const doc = getDocument();
	if (!doc) {
		return;
	}
	doc.defaultView?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
	for (let el = doc.querySelector(MAIN_CONTENT_SELECTOR); el; el = el.parentElement) {
		if (el.scrollTop !== 0) {
			el.scrollTop = 0;
		}
		if (el.scrollLeft !== 0) {
			el.scrollLeft = 0;
		}
	}
};
